module.exports = __webpack_public_path__ + "img/logo_nl.ec27e3f0.jpg";